import {
  FormB1,
  HeaderWithBulletPoints,
  TwoHeadersAndBulletPoints,
} from '@chegg-wt/core/types/core'

export const confirmContent: HeaderWithBulletPoints[] = [
  {
    header: 'What is this page?',
    body: [
      "It's a confirmation and notification page for the citation information we found (and did not find) for your source. We want to make sure that you are aware of what was found for the main citation elements, as well as what you may need to find yourself.",
    ],
  },
  {
    header:
      'How did you find the information? In some cases, why did you not find all of the details?',
    body: [
      'Our automatic citation feature takes the information you first inputted and looks at information in other resources and databases to see if we can find a match. If there is a match, we attempt to get as much citation information as possible. However, we are not the creators of the information from these other resources so sometimes there is data that is missing or incomplete.',
    ],
  },
  {
    header: 'What do I do with this information?',
    body: [
      'Review what is found and confirm that it matches the information you see in the actual resource you are using. If any information was not found, try to find it yourself in the actual resource.',
    ],
  },
  {
    header: 'What is the next step?',
    body: [
      'After reviewing what details were found and not found, click the “Final Step” button. A citation form will be shown with any found information already included. This is the best time to find and input any information that you know, as well as add any edits you think are needed. In addition, there is a spot at the bottom for you to add an annotation.',
    ],
  },
]

const formContent: TwoHeadersAndBulletPoints[] = [
  {
    header: 'Annotation',
    bodyHeader:
      'Extra notes about a source you are citing. Usually gives a brief summary and/or your thoughts about the source.',
  },
  {
    header: 'Date Accessed',
    bodyHeader: 'When (month, day, year) the source was accessed or reviewed online.',
  },
  {
    header: 'Electronically Published',
    bodyHeader:
      'The month, day, and year a content piece was published electronically (as opposed to in print). Depending on the webpage, it may or may not be shown.',
  },
  {
    header: 'Place of Publication',
    bodyHeader:
      'Where the publisher of the source is. Usually refers to a city, state, or country.',
  },
  {
    header: 'Publisher or Sponsor',
    bodyHeader:
      'Person or entity that supported the publishing or distribution of a work. For example, the publishing company of a book.',
  },
  {
    header: 'Suffix',
    bodyHeader:
      'Indicators at the end of a name that tell us more about a person. This includes Jr., Esq., PhD, etc.',
  },
  {
    header: 'Title',
    bodyHeader:
      'This is the name of the source. If no name exists, some citations ask for a description.',
  },
  {
    header: 'URL',
    bodyHeader:
      'Web address for a page on the internet. http://www.bibme.org/ is an example of a URL.',
  },
  {
    header: 'Medium',
    bodyHeader:
      'Manner or way a work was communicated or distributed. A few examples are:',
    body: [
      'E-book: Other - PDF, Powerpoint, MP4, etc.',
      'Painting/Artwork - Oil on canvas, Lithograph on paper, Glass, etc.',
    ],
  },
  {
    header: 'Contributor',
    bodyHeader:
      'An individual or group that contributed to the creation of the content you are citing. A translator, editor, producer, and inventor are a few examples.',
  },
  {
    header: 'Author',
    bodyHeader:
      'Individual who created a work such as a book, digital image, article, blog, comic, podcast, play, poem, script, etc.',
  },
]

export const formB1: FormB1 = {
  header: 'Glossary of Selected Terms',
  table: formContent,
}
